import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { GoThreeBars } from 'react-icons/go'
import { MdOutlineClose } from 'react-icons/md'
import Logo from '../Imagenes/logotipo.png'
import { links } from '../data'
import './navbar.css'

const Navbar = () => {
  const [open, setOpen] = useState(false)

  const closeNav = () => setOpen(false)
  const toggleNav = () => setOpen(prev => !prev)

  return (
    <nav className="nav">
      <div className="container nav-container">

        <Link to="/" className="nav-logo" onClick={closeNav}>
          <img src={Logo} alt="Logo" />
        </Link>

        <ul className={`nav-links ${open ? 'open' : ''}`}>
              {links.map(({ name, path }) => (
                <li key={name}>
                  {path.startsWith('http') ? (
                    <a
                        href={path}
                        onClick={closeNav}
                    >
                      {name}
                    </a>
                  ) : (
                    <NavLink
                      to={path}
                      className={({ isActive }) => isActive ? 'active' : ''}
                      onClick={closeNav}
                    >
                      {name}
                    </NavLink>
                  )}
                </li> 
          ))}
        </ul>

        <button className="nav-toggle" onClick={toggleNav}>
          {open ? <MdOutlineClose /> : <GoThreeBars />}
        </button>

      </div>
    </nav>
  )
}

export default Navbar
